import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Tour from "reactour";
import { useTranslation } from "react-i18next";
import {
  getTourSteps,
  getTourProgress,
  markTourCompleted,
} from "../config/tourSteps";

interface OnboardingTourProps {
  isFirstTime: boolean;
}

export const OnboardingTour = ({ isFirstTime }: OnboardingTourProps) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [runTour, setRunTour] = useState(false);
  const [tourSteps, setTourSteps] = useState(getTourSteps(t, pathname));

  useEffect(() => {
    const steps = getTourSteps(t, pathname);
    setTourSteps(steps);

    // Check if tour has been completed for this page
    const progress = getTourProgress();
    if (steps.length > 0 && !progress[pathname]) {
      setRunTour(true);
    }
  }, [pathname, t]);

  const handleTourCallback = (data: any) => {
    const { status } = data;
    if (["FINISHED", "SKIPPED"].includes(status)) {
      setRunTour(false);
      markTourCompleted(pathname);
    }
  };

  return tourSteps.length > 0 ? (
    <Tour
      steps={tourSteps}
      isOpen={runTour}
      onRequestClose={() => {
        setRunTour(false);
        markTourCompleted(pathname);
      }}
      onAfterOpen={(target) => (document.body.style.overflowY = "hidden")}
      onBeforeClose={(target) => (document.body.style.overflowY = "auto")}
      className="cultry-tour"
      rounded={8}
      accentColor="#4F46E5"
      closeWithMask={false}
      onRequestSkip={handleTourCallback}
    />
  ) : null;
};
